import * as Request from "common/utils/serverRequest";
import * as ServerHelper from "common/utils/serverHelper";
import * as serverPaths from "common/utils/serverPaths";
//---------------------------------------------------------------------------------------------------------------------------------
export function async_overviewRequest(dispatch, agencyId, fromDate, toDate) {
    // Get the dates as strings
    let dates = ServerHelper.convertDates(fromDate, toDate);
    // Create the request - either page or component level
    let requestPromise = Request.getComponentJson(dispatch, serverPaths.agencyOverviewRequestParams(agencyId, dates[0], dates[1]));
    // Make the request and deal with the response
    return requestPromise.then((response) => handleOverview(response), (error) => ServerHelper.handleResponseFailure(error));
}
function handleOverview(response) {
    return response.json()
        .then((json) => {
        return Promise.resolve(json);
    }, () => {
        return Promise.reject("Unknown error interpreting response");
    });
}
//-------------------------------------------------------------------------------------------------------------------------------
